
define('text!meetings/upcoming-meetings/upcoming-meetings.html',[],function () { return '<div data-bind="compose: \'meetings/upcoming-meetings/upcoming-meetings-view.html\'"></div>\n';});

